import React from 'react'
import styles from './DateRangePicker.module.scss'
import { Calendar } from 'lucide-react'
import type { AnalyticsDateRange } from '@/types/analytics'

interface DateRangePickerProps {
  activeRange: AnalyticsDateRange
  from: string
  to: string
  onRangeChange: (range: AnalyticsDateRange) => void
  onCustomFromChange: (date: string) => void
  onCustomToChange: (date: string) => void
  className?: never
}

const PRESETS: Array<{ key: AnalyticsDateRange; label: string }> = [
  { key: 'today', label: 'Today' },
  { key: '7d', label: '7D' },
  { key: '30d', label: '30D' },
  { key: '90d', label: '90D' },
  { key: 'custom', label: 'Custom' },
]

export const DateRangePicker: React.FC<DateRangePickerProps> = ({
  activeRange, from, to, onRangeChange, onCustomFromChange, onCustomToChange,
}) => (
  <div className={styles.wrapper}>
    <div className={styles.container}>
      <span className={styles.calendarIcon}>
        <Calendar size={14} />
      </span>
      {PRESETS.map((preset) => (
        <button
          key={preset.key}
          type="button"
          className={[styles.button, activeRange === preset.key ? styles.active : ''].join(' ')}
          onClick={() => onRangeChange(preset.key)}
        >
          {preset.label}
        </button>
      ))}
    </div>
    {activeRange === 'custom' && (
      <div className={styles.dateInputs}>
        <input
          type="date"
          value={from}
          onChange={(e) => onCustomFromChange(e.target.value)}
          className={styles.dateInput}
        />
        <span className={styles.dateSeparator}>to</span>
        <input
          type="date"
          value={to}
          onChange={(e) => onCustomToChange(e.target.value)}
          className={styles.dateInput}
        />
      </div>
    )}
  </div>
)
